import type { Environment } from "./types";

export const environment: Environment = {
  production: false,

  poolData: {
    CognitoUserPoolId: "eusc-de-east-1_uThbCnYyq",
    CognitoClientId: "65bqdqas0ip95ruh4s6q47af3a",
    CognitoEndpoint: "https://cognito-idp.eusc-de-east-1.amazonaws.eu/",
    Backend: "https://api.sbs.staging.peitel.com/",
  },
};
